<template>
  <b-container fluid>
    <b-row>
      <b-col class="my-3">
        <b-input-group>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="my-3">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small
          primary-key="id"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="getAllParkingInvoices"
          :fields="fields"
          @row-clicked="rowClicked"
          @filtered="onFiltered"
        >
          <template v-slot:cell(total_price)="item">
            {{ currencyFormat(item.item.total_price, item.item.currency) }}
          </template>
          <template v-slot:cell(is_paid)="item">
            <v-icon v-if="item.item.is_paid" name="regular/check-square" ></v-icon>
            <v-icon v-else name="regular/square" ></v-icon>
          </template>
          <template v-slot:cell(total_price_ex_vat)="item">
            {{
              currencyFormat(item.item.total_price_ex_vat, item.item.currency)
            }}
          </template>
          <template v-slot:cell(sent_at)="item">
            <div v-b-tooltip.hover :title="item.item.sent_at">
              {{ item.item.sent_at.substring(0, 10) }}
            </div>
          </template>
          <template v-slot:row-details="item">
            <b-container>
              <b-row>
                <b-col cols="3">
                  <b-btn
                    @click="toCustomer(item.item.customer_id)"
                    size="sm"
                    variant="info"
                    class="mx-1 float-right"
                  >
                    {{ $t("globals.customer") }}
                  </b-btn>
                  <b-btn
                    @click="openPdf(item.item.id)"
                    size="sm"
                    variant="info"
                    class="mx-1 float-right"
                  >
                    .pdf
                  </b-btn>
                </b-col>
              </b-row>
            </b-container>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="getAllParkingInvoices.length"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import { currencyFormat } from "@/helpers/price";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      filter: null,
      currentPage: 1,
      perPage: 20,
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        {
          key: "id",
          sortable: true
        },
        {
          key: "invoice_no",
          label: this.$t("globals.invoice_number"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "sent_at",
          label: this.$t("globals.sent_at"),
          sortable: true
        },
        {
          key: "sent_to",
          label: this.$t("globals.sent_to"),
          sortable: true
        },
        {
          key: "is_paid",
          label: this.$t("globals.paid"),
          sortable: true
        },
        {
          key: "total_price",
          label: this.$t("globals.total"),
          sortable: true
        },
        {
          key: "total_price_ex_vat",
          label: this.$t("globals.total_price_no_vat"),
          sortable: true
        },
        {
          key: "company_name",
          label: this.$t("globals.company"),
          sortable: true
        },
        {
          key: "user_name",
          label: this.$t("globals.user"),
          sortable: true
        }
      ]
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapActions("invoices", ["fetchAllParkingInvoices"]),
    currencyFormat,
    toCustomer(id) {
      this.$router.push({ name: "customer", params: { id: id } });
    },
    openPdf(id) {
      window.open(
        `${this.getBackendUrl}/pdf_parking_invoices/${id}.pdf?locale=${this.getLocale}`,
        "_blank"
      );
    },
    onFiltered() {
      this.currentPage = 1;
    },
    rowClicked(item) {
      item._rowVariant = null;
      item._showDetails = !item._showDetails;
      if (item._showDetails) {
        item._rowVariant = "info";

        this.$store.state.allParkingInvoices.forEach(invoice => {
          if (item.id == invoice.id) return;
          invoice._showDetails = false;
          invoice._rowVariant = null;
        });
      }
    }
  },
  computed: {
    ...mapGetters("invoices", ["getAllParkingInvoices"]),
    ...mapGetters([
      "getBackendUrl",
      "getDefConf",
      "getGraphQlUrl",
      "getLocale",
      "getUserBrandPermissions"
    ])
  },
  created() {
    this.fetchAllParkingInvoices();
  }
};
</script>
